import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchArticles = createAsyncThunk(
   'articles/fetchArticles',
   async (pageNum, thunkAPI) => {
      try {
         const response = await API.get(`/articles`, {params: {page: pageNum, limit: 5}})
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchArticles', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (articleName, { getState }) => {
         const { articles } = getState()
         if (articles.loading[articleName] || articles.loaded[articleName]) return false
      }
   }
)

const initialState = {
   entities: {},
   loading: {},
   loaded: {},
   pages: {},
   currentPage: 1,
   total: null,
}

const articlesSlice = createSlice({
   name: 'article',
   initialState,
   reducers: {
      setArticlesPage(state, action) {
         state.currentPage = action.payload
      }
   },
   extraReducers: builder => {
      builder.addCase(fetchArticles.pending, (state, action) => {
         const pageNum = action.meta.arg
         state.loading[pageNum] = true
         state.loaded[pageNum] = false
      })
      builder.addCase(fetchArticles.fulfilled, (state, action) => {
         const pageNum = action.meta.arg
         const { entities, total } = action.payload
         entities.forEach(item => (state.entities[item.url] = item))
         state.pages[pageNum] = entities.map(({ url }) => url)
         state.loading[pageNum] = false
         state.loaded[pageNum] = true
         if (state.total === null) state.total = total
      })
      builder.addCase(fetchArticles.rejected, (state, action) => {
         const pageNum = action.meta.arg
         state.loading[pageNum] = false
         state.loaded[pageNum] = false
      })
   }
})

export const articles = articlesSlice.reducer
export const { setArticlesPage } = articlesSlice.actions
